import apiClient from '../client'

interface LoginRequest {
  tenantCode: string
  username: string
  password: string
}

interface LoginResponse {
  accessToken: string
  refreshToken: string
  accessTokenExpiresAt: string
  userId: string
  username: string
  fullName: string
  roles: string[]
  tenantId: string
  tenantCode: string
  tenantName: string
  isPlatform: boolean
}

interface RefreshTokenRequest {
  refreshToken: string
}

interface SwitchTenantRequest {
  tenantId: string
}

interface SwitchRoleRequest {
  roleId: string
}

const BASE_PATH = '/auth'

export const authService = {
  async login(tenantCode: string, username: string, password: string): Promise<LoginResponse> {
    return apiClient.post<LoginResponse, LoginRequest>(`${BASE_PATH}/login`, { tenantCode, username, password })
  },

  async refresh(refreshToken: string): Promise<LoginResponse> {
    return apiClient.post<LoginResponse, RefreshTokenRequest>(`${BASE_PATH}/refresh`, { refreshToken })
  },

  async switchTenant(tenantId: string): Promise<LoginResponse> {
    return apiClient.post<LoginResponse, SwitchTenantRequest>(`${BASE_PATH}/switch-tenant`, { tenantId })
  },

  async switchRole(roleId: string): Promise<LoginResponse> {
    return apiClient.post<LoginResponse, SwitchRoleRequest>(`${BASE_PATH}/switch-role`, { roleId })
  },

  async logout(refreshToken: string): Promise<void> {
    return apiClient.post<void, RefreshTokenRequest>(`${BASE_PATH}/logout`, { refreshToken })
  },
}

export type { LoginResponse }
